<div class="wrap" id="ligue">
  <div class="background_search_bar">
    <div class="search_bar">
      <form [formGroup]="searchForm">
        <input type="text" placeholder="Chercher un article ..." (input)="applyFilter($event.target.value)"
          formControlName="keyword">
        <fa-icon [icon]="faTimes" (click)="resetSearch(); scrollToElement()" *ngIf="valueInput"></fa-icon>
      </form>
      <fa-icon [icon]="faSearch"></fa-icon>
    </div>
    <fa-icon [icon]="faList" (click)="choiceLigueInList()"></fa-icon>

  </div>
  <p *ngIf="noFlux" class="no_flux">Veuillez choisir une ligue.</p>

  <div class="flux_actu" *ngIf="!(itemsFluxFilter?.length === 0 && valueInput) && !noFlux && itemsFlux.length">
    <div #target id="target"></div>

    <div class="load" *ngIf="load">
      <mat-spinner [diameter]="50" [color]="color"></mat-spinner>
    </div>
    <ng-container *ngFor="let a of itemsFluxFilter && itemsFluxFilter.length? itemsFluxFilter : itemsFlux">
      <app-item-flux-rss [item]="a"></app-item-flux-rss>
    </ng-container>
    <div class="end_flux" (click)="scrollToElement()" *ngIf="itemsFlux.length">
      <fa-icon [icon]="faChevronUp"></fa-icon>
      <p>Il n'y a plus d'articles</p>
    </div>
  </div>
  <p *ngIf="itemsFluxFilter?.length === 0 && valueInput && !noFlux" class="message_search">Il n'y a pas de résultats
  </p>

  <div class="skeleton">
    <app-skeleton-flux *ngIf="!itemsFlux.length"></app-skeleton-flux>
  </div>


  <!-- <a class="up" (click)="scrollToElement(target)">
    <fa-icon [icon]="faArrowUp"></fa-icon>
  </a> -->
</div>